import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import type { Action } from '../../types';
import categoriesActionKeys from './categoryGroupActionKeys';
import type { GetCategoryGroupResponse } from './categoryGroupService';

export type GetCategoryGroupResponseAction = Action<{
  body: GetCategoryGroupResponse,
}>;

export default (combineReducers({
  getCategoryGroup:
    AsyncRequest.createReducer(categoriesActionKeys.GET_CATEGORY_GROUP, {
      [categoriesActionKeys.GET_CATEGORY_GROUP_SUCCESS]:
        (
          state,
          action: GetCategoryGroupResponseAction,
        ) => {
          action.addSideEffect((store) => {});
          return AsyncRequest.setSuccess(state, action.payload.body);
        },
    }),
}): any);



// WEBPACK FOOTER //
// ./src/app/common/category-group/categoryGroupReducer.js